import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Features from "./pages/Features";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Resources from "./pages/Resources";
import Contact from "./pages/Contact";
import FreeTrialInfo from "./pages/FreeTrialInfo";
import FreeTrialPayment from "./pages/FreeTrialPayment";
import Payment from "./pages/Payment";
import PaymentSuccess from "./pages/PaymentSuccess";
import Onboarding from "./pages/Onboarding";
import Blog1 from "./pages/Blog/Blog1";
import Blog2 from "./pages/Blog/Blog2";
import Blog3 from "./pages/Blog/Blog3";
import Blog4 from "./pages/Blog/Blog4";
import Blog5 from "./pages/Blog/Blog5";
import Blog6 from "./pages/Blog/Blog6";
import Blog7 from "./pages/Blog/Blog7";
import Blog8 from "./pages/Blog/Blog8";
import Blog9 from "./pages/Blog/Blog9";
import Blog10 from "./pages/Blog/Blog10";
import CaseStudy1 from "./pages/CaseStudies/CaseStudy1";
import CaseStudy2 from "./pages/CaseStudies/CaseStudy2";
import CaseStudy3 from "./pages/CaseStudies/CaseStudy3";
import CaseStudy4 from "./pages/CaseStudies/CaseStudy4";
import CaseStudy5 from "./pages/CaseStudies/CaseStudy5";
import CaseStudy6 from "./pages/CaseStudies/CaseStudy6";
import CaseStudy7 from "./pages/CaseStudies/CaseStudy7";
import HowItWorks from "./pages/HowItWorks";
import Team from "./pages/Team";
import TestPricing from "./pages/testpricing";
import ROI from "./pages/ROI";

const App: React.FC = () => (
  <Router>
    <Navbar />
    <main className="min-h-screen pt-20 pb-16 bg-gray-50">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Home />} />
        <Route path="/features" element={<Features />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/about" element={<About />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/free-trial" element={<FreeTrialInfo />} />
        <Route path="/free-trial/payment" element={<FreeTrialPayment />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/blog/5-ways-to-improve-snf-compliance" element={<Blog1 />} />
        <Route path="/blog/future-of-digital-rounds" element={<Blog2 />} />
        <Route path="/blog/leveraging-data-analytics" element={<Blog3 />} />
        <Route path="/blog/telemedicine-adoption" element={<Blog4 />} />
        <Route path="/blog/enhancing-infection-control" element={<Blog5 />} />
        <Route path="/blog/improving-staff-retention" element={<Blog6 />} />
        <Route path="/blog/family-engagement" element={<Blog7 />} />
        <Route path="/blog/sustainable-practices" element={<Blog8 />} />
        <Route path="/blog/mobile-apps-in-care" element={<Blog9 />} />
        <Route path="/blog/reducing-readmissions" element={<Blog10 />} />
        <Route path="/case-study/compliance-success" element={<CaseStudy1 />} />
        <Route path="/case-study/survey-readiness" element={<CaseStudy2 />} />
        <Route path="/case-study/infection-control" element={<CaseStudy3 />} />
        <Route path="/case-study/digital-documentation" element={<CaseStudy4 />} />
        <Route path="/case-study/fall-prevention" element={<CaseStudy5 />} />
        <Route path="/case-study/medication-safety" element={<CaseStudy6 />} />
        <Route path="/case-study/wound-care" element={<CaseStudy7 />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/team" element={<Team />} />
        <Route path="/test" element={<TestPricing />} />
        <Route path="/roi" element={<ROI />} />
      </Routes>
    </main>
    <Footer />
  </Router>
);

export default App; 